import { z } from 'zod';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OrderCreatedEvent = z.object({
    orderId: z.string().uuid(),
});

export type OrderCreatedEventPayload = z.infer<typeof OrderCreatedEvent>;
